module.exports = __webpack_public_path__ + "static/media/11.71bf7eb7.jpeg";